let widgetPortalContainer: HTMLElement | null = null
let widgetRuntimeActive = false

export function setWidgetRuntimeActive(active: boolean) {
  widgetRuntimeActive = active
}

export function isWidgetRuntimeActive() {
  return widgetRuntimeActive
}

export function setWidgetPortalContainer(container: HTMLElement | null) {
  widgetPortalContainer = container
}

export function getWidgetPortalContainer() {
  if (widgetPortalContainer) {
    return widgetPortalContainer
  }
  return typeof document === 'undefined' ? null : document.body
}

export function isWidgetPortalActive() {
  return typeof document !== 'undefined'
    && widgetPortalContainer !== null
    && widgetPortalContainer !== document.body
}
